/**
 * La configurazione del server di posta, letta dal backend.
 *
 * Sta in un hook e non nell'impalcatura di «Impostazioni» perché delle quattro
 * sezioni solo tre la usano: tenerla di sopra vorrebbe dire chiedere al
 * backend la casella di posta anche a chi è entrato solo per aggiungere un
 * collega, e far aspettare quella risposta prima di mostrargli l'elenco.
 */
import { useCallback, useEffect, useState } from 'react';

import { impostazioni as apiImpostazioni } from '../../api/scadenziario.ts';
import type { ConfigurazioneSmtp } from '../../api/tipi-dati.ts';

export function useConfigurazioneSmtp() {
  const [config, setConfig] = useState<ConfigurazioneSmtp | null>(null);
  const [errore, setErrore] = useState<string | null>(null);
  const [giro, setGiro] = useState(0);

  useEffect(() => {
    let annullato = false;

    apiImpostazioni
      .leggiSmtp()
      .then((r) => { if (!annullato) { setConfig(r); setErrore(null); } })
      .catch((e: unknown) => {
        if (!annullato) setErrore(e instanceof Error ? e.message : 'Errore imprevisto');
      });

    return () => { annullato = true; };
  }, [giro]);

  /**
   * Rilegge la configurazione. Da chiamare dopo un salvataggio o una prova
   * d'invio riuscita: sono le due cose che cambiano lo stato «invio attivo»,
   * e quello lo si sta guardando proprio mentre lo si cambia.
   */
  const rileggi = useCallback(() => setGiro((n) => n + 1), []);

  return { config, errore, rileggi };
}
